import { format } from "date-fns";

export const MAX_PDF_SIZE_BYTES = 10 * 1024 * 1024;

export const formatDocumentDate = (value) => {
  if (!value) {
    return "-";
  }

  try {
    return format(new Date(value), "dd MMM yyyy");
  } catch (error) {
    return "-";
  }
};

export const formatFileSize = (bytes = 0) => {
  if (!bytes || bytes < 1024) return `${bytes || 0} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const isPdfFile = (file) => {
  if (!file) {
    return false;
  }

  const nameIsPdf = file.name?.toLowerCase().endsWith(".pdf");
  const typeIsPdf = !file.type || file.type === "application/pdf";
  return nameIsPdf && typeIsPdf;
};

export const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Could not read the PDF file."));
    reader.readAsDataURL(file);
  });

export const getDocumentFile = (document) => {
  const metadata = document?.metadata || {};
  const fileName =
    metadata.fileName ||
    (document?.content?.toLowerCase?.().endsWith(".pdf")
      ? document.content
      : "");

  return {
    fileName,
    fileSize: metadata.fileSize || 0,
    fileType: metadata.fileType || "application/pdf",
    fileData: metadata.fileData || "",
  };
};
